import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useHistory } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "authentication";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

const Download = () => {
  const history = useHistory()
  let { params } = useParams();  // 获取路径参数
  let url = params + history.location.search;
  let errorMessageText = 'Error!';

  useEffect(() => {
    let urlParams = new URLSearchParams(history.location.search);
    let filename = urlParams.get('filename');
    document.title = filename;

    httpClient({
      method: 'get',
      url: url,
      responseType: 'blob'
    })
      .then(({ data }) => {
        if (data != null) {
          if (data.type === 'text/plain') {
            let blobUrl = URL.createObjectURL(data);
            let iframeElement = document.getElementById("myIframe");
            iframeElement.src = blobUrl;
          } else {
            let blobUrl = URL.createObjectURL(data);
            let iframeElement = document.getElementById("myIframe");
            if (globalFunction.isMobile()) {
              if (globalFunction.isIOS()) {
                globalFunction.saveFile(blobUrl, filename);
              } else {
                iframeElement.src = '/assets/pdfjs/web/viewer.html?file=' + blobUrl;
              }
            } else {
              iframeElement.src = blobUrl;
            }
          }
        } else {
          history.push('/error?type=UI&message=No File Data: ' + filename);
        }
      })
      .catch(function (error) {
      });
  }, []);

  return (
    <iframe id="myIframe" style={{ width: '100%', height: 'calc(100vh - 6px)' }} />
  );
};

export default Download;
